(() => {
  if (window.UnionBusinessUI) return;
  window.UnionBusinessUI = true;
  const openers = new WeakMap(), initialized = new WeakSet();
  const reduce = matchMedia('(prefers-reduced-motion: reduce)');
  const language = () => window.UnionLanguage?.language === 'es' ? 'Spanish' : 'English';
  function open(dialog, trigger) {
    if (!dialog || dialog.open) return;
    if (trigger) openers.set(dialog, trigger);
    dialog.showModal();
    dialog.querySelector('[data-business-language]').value = language();
    (dialog.querySelector('[data-business-result]') || dialog.querySelector('input:not([type="hidden"])'))?.focus();
  }
  function init(root) {
    root.querySelectorAll('[data-union-business]').forEach(section => {
      if (initialized.has(section)) return;
      initialized.add(section);
      const dialog = section.querySelector('[data-business-dialog]');
      dialog.addEventListener('close', () => openers.get(dialog)?.focus());
      if (dialog.querySelector('[data-business-result]')) open(dialog);
      if (!('IntersectionObserver' in window)) return;
      const observer = new IntersectionObserver(entries => {
        entries.filter(entry => entry.isIntersecting).forEach(({target}) => {
          observer.unobserve(target); target.dataset.businessReveal = 'shown';
          if (reduce.matches || !target.animate) return;
          const animation = target.animate([{opacity:0,translate:'0 24px'},{opacity:1,translate:'0 0'}],{
            duration:850,delay:Number(target.style.getPropertyValue('--business-order') || 0)*170,
            easing:'cubic-bezier(.22,1,.36,1)',fill:'backwards'
          });
          animation.id='union-business-intro';
        });
      },{threshold:.12});
      section.querySelectorAll('[data-business-reveal]').forEach(element => observer.observe(element));
      section.addEventListener('shopify:section:unload', () => observer.disconnect(),{once:true});
    });
  }
  document.addEventListener('click', event => {
    const trigger=event.target.closest('[data-business-open]');
    if(trigger){const dialog=document.getElementById(trigger.getAttribute('aria-controls'));if(dialog && typeof dialog.showModal==='function'){event.preventDefault();open(dialog,trigger);}}
    const close=event.target.closest('[data-business-close]');
    if(close) close.closest('dialog').close();
    if(event.target.matches('[data-business-dialog]')){const rect=event.target.getBoundingClientRect();if(event.clientX<rect.left || event.clientX>rect.right || event.clientY<rect.top || event.clientY>rect.bottom)event.target.close();}
  });
  document.addEventListener('union:languagechange',()=>document.querySelectorAll('[data-business-language]').forEach(field=>field.value=language()));
  document.addEventListener('shopify:section:load',event=>init(event.target));
  document.addEventListener('shopify:block:select',event=>event.target.querySelectorAll('[data-business-reveal]').forEach(element=>element.getAnimations().forEach(animation=>animation.finish())));
  init(document);
})();
